import React from "react"
import ReactDOM from "react-dom"
import TimelineblockComponent from "./timeline-block-component"

export default class TimelineBlock {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TimelineblockComponent {...this.modelJson} />, self.elem)
  }
}
